// Status pill row shared by the approver, IT and admin request lists. Every
// role can see the whole board, so each pill also carries how many rows it holds.

const STATUSES = ['all', 'pending', 'approved', 'rejected', 'in_progress', 'completed'];

const COLORS = {
  all:         '#0d1a6e',
  pending:     '#f59e0b',
  approved:    '#4f6ef7',
  rejected:    '#dc2626',
  in_progress: '#ea580c',
  completed:   '#7c3aed',
};

const StatusFilter = ({ value, onChange, requests = [] }) => {
  const countFor = s =>
    s === 'all' ? requests.length : requests.filter(r => r.status === s).length;

  return (
    <div style={S.row}>
      {STATUSES.map(s => {
        const color = COLORS[s];
        const isActive = value === s;
        return (
          <button
            key={s}
            type="button"
            onClick={() => onChange(s)}
            style={{
              ...S.pill,
              background: isActive ? color : `${color}15`,
              color: isActive ? '#fff' : color,
            }}
          >
            {s.replace('_', ' ')}
            <span style={{ ...S.count, color: isActive ? 'rgba(255,255,255,0.75)' : `${color}99` }}>
              {countFor(s)}
            </span>
          </button>
        );
      })}
    </div>
  );
};

const S = {
  row: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  pill: {
    display: 'flex', alignItems: 'center', gap: 7,
    padding: '7px 18px', borderRadius: 20, border: 'none',
    cursor: 'pointer', fontSize: 12.5, fontWeight: 700,
    transition: 'all 0.15s', letterSpacing: 0.3, textTransform: 'capitalize',
  },
  count: { fontSize: 11, fontWeight: 800 },
};

export default StatusFilter;
